<template>
  <svg :class="'icon'" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M7.19961 3.89961C7.19961 5.72215 5.72215 7.19961 3.89961 7.19961C2.07707 7.19961 0.599609 5.72215 0.599609 3.89961C0.599609 2.07707 2.07707 0.599609 3.89961 0.599609C5.72215 0.599609 7.19961 2.07707 7.19961 3.89961Z"
      :fill="color"
    />
    <circle cx="3.89961" cy="15.0002" r="3.3" :fill="color" />
    <path
      d="M4 15V4H15V9.5V15H4Z"
      :stroke="color"
      stroke-width="2.6"
      stroke-linejoin="round"
    />
    <circle cx="15.0002" cy="3.89961" r="3.3" :fill="color" />
    <circle cx="15.0002" cy="15.0002" r="3.3" :fill="color" />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: '#000000',
  },
})
</script>

<style lang="scss" scoped></style>
